
// import React, { useEffect, useState } from 'react';
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
// import './advertisement.css';
// import { useSelector } from 'react-redux';
// import Modal from '../../sharedFiles/Modal/modal';
// const AdvertisementModel = ({ open, onClose,offautoImage }) => {
//   const { AdversitmentImage } = useSelector((state) => state.CustomerMaster);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   useEffect(() => {
//     if ( !Array.isArray(AdversitmentImage) || AdversitmentImage.length === 0) return;
//     const interval = setInterval(() => {
//       setCurrentIndex((prev) =>
//         prev === AdversitmentImage.length - 1 ? 0 : prev + 1
//       );
//     }, 1700);
//     return () => clearInterval(interval);
//   }, [open, AdversitmentImage]);


//   // const handlePrev = () => {
//   //   setCurrentIndex((prev) => (prev === 0 ? AdversitmentImage.length - 1 : prev - 1));
//   // };

//   // const handleNext = () => {
//   //   setCurrentIndex((prev) => (prev === AdversitmentImage.length - 1 ? 0 : prev + 1));
//   // };

//   const handleClose = (event, reason) => {
//     if (reason === 'backdropClick') {
//       return;
//     }
//     onClose();
//   };
//   const hasImages = Array.isArray(AdversitmentImage) && AdversitmentImage.length > 0;
//   const currentImage = hasImages ? AdversitmentImage[currentIndex] : null;
//   return (
//     <Modal isOpen={open} onClose={handleClose} title="Offers">
//       <div className="ad-modal-wrapper">
//         {/* <button className="nav-arrow left-arrow" onClick={handlePrev}>
//       <ArrowBackIosNewIcon />
//     </button> */}
//          {hasImages && currentImage?.base64Data ? (
//           <img
//             src={`data:image/png;base64,${currentImage.base64Data}`}
//             alt={`Ad ${currentIndex + 1}`}
//             className="custom-dialog-image"
//           />
//         ) : (
//           <div>No advertisement images available</div>
//         )}
//         {/* <button className="nav-arrow right-arrow" onClick={handleNext}>
//       <ArrowForwardIosIcon />
//     </button> */}
//       </div>
//     </Modal>
//   );
// };

// export default AdvertisementModel;
import React, { useEffect, useState, useRef } from 'react';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import './advertisement.css';
import { useSelector } from 'react-redux';
import Modal from '../../sharedFiles/Modal/modal';

const AdvertisementModel = ({ open, onClose, offautoImage }) => {
  const { AdversitmentImage } = useSelector((state) => state.CustomerMaster);
  const [currentIndex, setCurrentIndex] = useState(0);
  const isValidImageArray = Array.isArray(AdversitmentImage) && AdversitmentImage.length > 0;

  useEffect(() => {
    if (!open) {
      setCurrentIndex(0);
      return;
    }
    if (!isValidImageArray || offautoImage) return;
    // Auto slide images every 1.7 seconds
    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === AdversitmentImage.length - 1 ? 0 : prev + 1
      );
    }, 1700);

    return () => clearInterval(interval);
  }, [open, AdversitmentImage, offautoImage]);

  // Manual navigation handlers
  const handlePrev = () => {
    if(!isValidImageArray) return;
    setCurrentIndex((prev) =>
      prev === 0 ? AdversitmentImage.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    if(!isValidImageArray) return;
    setCurrentIndex((prev) =>
      prev === AdversitmentImage.length - 1 ? 0 : prev + 1
    );
  };

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    onClose();
  };

  const hasImages = Array.isArray(AdversitmentImage) && AdversitmentImage.length > 0;
  const currentImage = hasImages ? AdversitmentImage[currentIndex] : null;

  return (
    <Modal isOpen={open} onClose={handleClose} title="Offers" >
      <div className="ad-modal-wrapper">
        {/* Show manual navigation buttons only if offautoImage is true */}
        {offautoImage && (
          <button className="nav-arrow left-arrow" onClick={handlePrev}>
            <ArrowBackIosNewIcon />
          </button>
        )}

        {hasImages && currentImage?.base64Data ? (
          <img
            src={`data:image/png;base64,${currentImage.base64Data}`}
            alt={`Ad ${currentIndex + 1}`}
            className="custom-dialog-image"
          />
        ) : (
          <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: '100%', minHeight: '150px', fontSize: '1.2rem', color: '#666' }}
        >
          <span role="img" aria-label="no ads" style={{ marginRight: '8px' }}>🚫</span>
          No advertisement images available
        </div>
        
        )}

        {offautoImage && (
          <button className="nav-arrow right-arrow" onClick={handleNext}>
            <ArrowForwardIosIcon />
          </button>
        )}
      </div>
    </Modal>
  );
};

export default AdvertisementModel;
